import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function RiskCheck() {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(false);
  const [checkComplete, setCheckComplete] = useState(false);

  const handleStartCheck = () => {
    setIsChecking(true);
    setTimeout(() => {
      setIsChecking(false);
      setCheckComplete(true);
    }, 3000);
  };

  const checkResults = {
    overall: {
      score: 85,
      level: '良好',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    categories: [
      {
        name: '合规性检查',
        score: 90,
        status: 'pass',
        issues: 2,
        icon: 'ri-shield-check-line',
        color: 'text-green-600',
      },
      {
        name: '完整性检查',
        score: 95,
        status: 'pass',
        issues: 1,
        icon: 'ri-checkbox-circle-line',
        color: 'text-green-600',
      },
      {
        name: '矛盾性检查',
        score: 75,
        status: 'warning',
        issues: 5,
        icon: 'ri-alert-line',
        color: 'text-yellow-600',
      },
      {
        name: '倾向性检查',
        score: 80,
        status: 'warning',
        issues: 3,
        icon: 'ri-eye-line',
        color: 'text-orange-600',
      },
    ],
  };

  const detailedIssues = [
    {
      id: 1,
      type: 'error',
      category: '合规性',
      title: '投标保证金金额超过规定上限',
      description: '招标文件中设置的投标保证金为估算价的2.5%，超过《招标投标法实施条例》规定的2%上限。',
      location: '第二部分 投标人须知前附表 第3.4.1条',
      suggestion: '建议将投标保证金调整为估算价的2%或以下。',
      reference: '《招标投标法实施条例》第26条',
      severity: 'high',
    },
    {
      id: 2,
      type: 'warning',
      category: '矛盾性',
      title: '工期要求前后不一致',
      description: '投标人须知前附表中要求工期为24个月，但专用合同条款中约定工期为730天（约24.3个月）。',
      location: '第二部分 投标人须知前附表 vs 第四部分 专用合同条款',
      suggestion: '建议统一工期表述，采用相同的计量单位和数值。',
      reference: '',
      severity: 'medium',
    },
    {
      id: 3,
      type: 'warning',
      category: '倾向性',
      title: '疑似品牌倾向性表述',
      description: '技术规范中要求"沥青采用某某品牌或同等产品"，可能被质疑为倾向性条款。',
      location: '第五部分 技术规范 第3.2.1条',
      suggestion: '建议修改为性能指标要求，如"沥青应满足以下技术指标：针入度、延度、软化点..."，避免指定品牌。',
      reference: '《招标投标法实施条例》第32条',
      severity: 'medium',
    },
    {
      id: 4,
      type: 'info',
      category: '完整性',
      title: '缺少开标时间和地点',
      description: '投标人须知前附表中未明确开标的具体时间和地点。',
      location: '第二部分 投标人须知前附表',
      suggestion: '建议补充开标时间和地点信息。',
      reference: '',
      severity: 'low',
    },
    {
      id: 5,
      type: 'warning',
      category: '矛盾性',
      title: '评分标准权重总和不等于100',
      description: '评标办法中商务部分20分、技术部分40分、报价部分35分，总计95分，未达到100分。',
      location: '第三部分 评标办法',
      suggestion: '建议调整各部分权重，确保总分为100分。',
      reference: '',
      severity: 'high',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/agent/dashboard')} className="text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div>
                <h1 className="text-xl font-bold text-gray-900">智能审查与风险预警系统</h1>
                <p className="text-sm text-gray-500">AI驱动的招标文件智能审查</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6">
        {/* Check Control Panel */}
        {!checkComplete && (
          <div className="bg-white rounded-xl shadow-sm p-8 mb-6">
            <div className="max-w-3xl mx-auto text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-red-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3">招标文件智能审查</h2>
              <p className="text-gray-600 mb-8">
                AI将对招标文件进行全面审查，包括合规性、完整性、矛盾性和倾向性检查
              </p>

              {!isChecking ? (
                <button
                  onClick={handleStartCheck}
                  className="px-8 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-xl hover:from-orange-700 hover:to-red-700 whitespace-nowrap cursor-pointer text-lg font-semibold"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  开始智能审查
                </button>
              ) : (
                <div className="space-y-4">
                  <div className="flex items-center justify-center space-x-3">
                    <div className="w-8 h-8 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
                    <span className="text-lg font-semibold text-gray-900">正在审查中...</span>
                  </div>
                  <div className="max-w-md mx-auto">
                    <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-orange-600 to-red-600 rounded-full animate-pulse" style={{ width: '60%' }}></div>
                    </div>
                  </div>
                </div>
              )}

              {/* Check Items Preview */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
                <div className="p-4 bg-green-50 rounded-lg">
                  <i className="ri-shield-check-line text-3xl text-green-600 mb-2"></i>
                  <div className="text-sm font-semibold text-gray-900">合规性扫描</div>
                </div>
                <div className="p-4 bg-blue-50 rounded-lg">
                  <i className="ri-checkbox-circle-line text-3xl text-blue-600 mb-2"></i>
                  <div className="text-sm font-semibold text-gray-900">完整性检查</div>
                </div>
                <div className="p-4 bg-yellow-50 rounded-lg">
                  <i className="ri-alert-line text-3xl text-yellow-600 mb-2"></i>
                  <div className="text-sm font-semibold text-gray-900">矛盾性检查</div>
                </div>
                <div className="p-4 bg-orange-50 rounded-lg">
                  <i className="ri-eye-line text-3xl text-orange-600 mb-2"></i>
                  <div className="text-sm font-semibold text-gray-900">倾向性检查</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Check Results */}
        {checkComplete && (
          <>
            {/* Overall Score */}
            <div className="bg-white rounded-xl shadow-sm p-8 mb-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-6">
                  <div className={`w-32 h-32 ${checkResults.overall.bgColor} rounded-2xl flex items-center justify-center`}>
                    <div className="text-center">
                      <div className={`text-4xl font-bold ${checkResults.overall.color}`}>
                        {checkResults.overall.score}
                      </div>
                      <div className="text-sm text-gray-600 mt-1">综合评分</div>
                    </div>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">审查完成</h2>
                    <p className="text-gray-600 mb-4">
                      文件质量等级：<span className={`font-bold ${checkResults.overall.color}`}>{checkResults.overall.level}</span>
                    </p>
                    <div className="flex items-center space-x-4 text-sm">
                      <span className="flex items-center space-x-1">
                        <i className="ri-error-warning-line text-red-600"></i>
                        <span>2个严重问题</span>
                      </span>
                      <span className="flex items-center space-x-1">
                        <i className="ri-alert-line text-yellow-600"></i>
                        <span>6个警告</span>
                      </span>
                      <span className="flex items-center space-x-1">
                        <i className="ri-information-line text-blue-600"></i>
                        <span>3个建议</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <button className="px-6 py-3 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 whitespace-nowrap cursor-pointer">
                    <i className="ri-download-line mr-2"></i>
                    导出报告
                  </button>
                  <button className="px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 whitespace-nowrap cursor-pointer">
                    <i className="ri-refresh-line mr-2"></i>
                    重新审查
                  </button>
                </div>
              </div>
            </div>

            {/* Category Scores */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
              {checkResults.categories.map((category, idx) => (
                <div key={idx} className="bg-white rounded-xl shadow-sm p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className={`w-12 h-12 ${category.status === 'pass' ? 'bg-green-100' : 'bg-yellow-100'} rounded-lg flex items-center justify-center`}>
                      <i className={`${category.icon} text-2xl ${category.color}`}></i>
                    </div>
                    <div className={`text-3xl font-bold ${category.color}`}>{category.score}</div>
                  </div>
                  <h3 className="font-bold text-gray-900 mb-2">{category.name}</h3>
                  <p className="text-sm text-gray-600">
                    发现 <span className="font-semibold text-gray-900">{category.issues}</span> 个问题
                  </p>
                </div>
              ))}
            </div>

            {/* Detailed Issues */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6">问题详情</h3>
              <div className="space-y-4">
                {detailedIssues.map((issue) => (
                  <div
                    key={issue.id}
                    className={`border-l-4 rounded-lg p-6 ${
                      issue.severity === 'high'
                        ? 'border-red-500 bg-red-50'
                        : issue.severity === 'medium'
                        ? 'border-yellow-500 bg-yellow-50'
                        : 'border-blue-500 bg-blue-50'
                    }`}
                  >
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-start space-x-3 flex-1">
                        <div
                          className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                            issue.severity === 'high'
                              ? 'bg-red-500'
                              : issue.severity === 'medium'
                              ? 'bg-yellow-500'
                              : 'bg-blue-500'
                          }`}
                        >
                          <i
                            className={`${
                              issue.severity === 'high'
                                ? 'ri-error-warning-line'
                                : issue.severity === 'medium'
                                ? 'ri-alert-line'
                                : 'ri-information-line'
                            } text-xl text-white`}
                          ></i>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center space-x-3 mb-2">
                            <h4 className="text-lg font-bold text-gray-900">{issue.title}</h4>
                            <span
                              className={`px-3 py-1 rounded-full text-xs font-semibold ${
                                issue.severity === 'high'
                                  ? 'bg-red-200 text-red-800'
                                  : issue.severity === 'medium'
                                  ? 'bg-yellow-200 text-yellow-800'
                                  : 'bg-blue-200 text-blue-800'
                              }`}
                            >
                              {issue.category}
                            </span>
                          </div>
                          <p className="text-gray-700 mb-3">{issue.description}</p>
                          <div className="space-y-2 text-sm">
                            <div className="flex items-start space-x-2">
                              <i className="ri-map-pin-line text-gray-500 mt-0.5"></i>
                              <span className="text-gray-600">
                                <strong>位置：</strong>{issue.location}
                              </span>
                            </div>
                            <div className="flex items-start space-x-2">
                              <i className="ri-lightbulb-line text-green-600 mt-0.5"></i>
                              <span className="text-gray-700">
                                <strong>建议：</strong>{issue.suggestion}
                              </span>
                            </div>
                            {issue.reference && (
                              <div className="flex items-start space-x-2">
                                <i className="ri-book-line text-purple-600 mt-0.5"></i>
                                <span className="text-gray-600">
                                  <strong>法规依据：</strong>{issue.reference}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2 ml-4">
                        <button className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-white whitespace-nowrap cursor-pointer text-sm">
                          忽略
                        </button>
                        <button className="px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 whitespace-nowrap cursor-pointer text-sm">
                          <i className="ri-edit-line mr-1"></i>
                          修正
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
